import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter, Route, Routes } from "react-router";

import { Account } from "pages/account";
import { Accounts } from "pages/accounts";
import { Connect } from "pages/connect";
import { Dev } from "pages/dev/dev";
import { Preferences } from "pages/preferences";
import { Settings } from "pages/settings";
import { Start } from "pages/start";
import { Subscription } from "pages/subscription";
import { AuthProvider } from "shared/providers/auth/provider";
import { RqProvider } from "shared/providers/rq/provider";

import { Fallback } from "./fallback";
import "./styles/index.css";

export const App = () => {
  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <Fallback error={error} resetErrorBoundary={resetErrorBoundary} />
      )}
    >
      <RqProvider>
        <BrowserRouter>
          <Routes>
            <Route
              element={
                <AuthProvider
                  renderError={(error) => {
                    console.error(error);
                    return <div>Error</div>;
                  }}
                />
              }
            >
              <Route path="/v2/dev" element={<Dev />} />
              <Route path="/" element={<Start />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/accounts" element={<Accounts />} />
              <Route path="/account/:name" element={<Account />} />
              <Route path="/preferences" element={<Preferences />} />
              <Route path="/connect/:type" element={<Connect />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </RqProvider>
    </ErrorBoundary>
  );
};
